import { fetchFromOldApi } from '~/services/Http';

import { AnswerPreProcess } from '../../../../types';
export { prefetchCustomData } from './prefetchCustomData';

export const saveCustomFieldValues = (
  employeeId: string,
  customFieldValues: AnswerPreProcess,
) => {
  return fetchFromOldApi(`/json/customdata/EMPLOYEE/${employeeId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      Accept: 'application/json; text/javascript; */*; q=0.01',
    },
    body: JSON.stringify(customFieldValues),
  }).then((r) => r.json());
};
